var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon",class:( _obj = {}, _obj[_vm.classType] = true, _obj[_vm.className] = true, _obj )})}
var staticRenderFns = []

export { render, staticRenderFns }